module.exports = __webpack_public_path__ + "files/3f498614e8105992e3f5ee1ff0e916e7.png";